import { debounceCallback } from '@utils/utils';
import { useEffect, useState } from 'react';

export const useDebouncedValue = (value: string, timeout: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const handleDebouncedValue = debounceCallback(() => setDebouncedValue(value), timeout);

  useEffect(() => {
    handleDebouncedValue();
  }, [value, handleDebouncedValue]);

  return debouncedValue;
};
